export enum RelativeDates {
    Today = "Today",
    Yesterday = "Yesterday",
    Last7Days = "Last7Days",
    Last14Days = "Last14Days",
    Last30Days = "Last30Days",
    LastWeek = "LastWeek",
    LastMonth = "LastMonth",
    WeekToDate = "WeekToDate",
    MonthToDate = "MonthToDate",
}
export type RelativeDateInfo = {
    name: RelativeDates;
    formatedName: string;
    startDate: Date;
    endDate: Date;
};

export const relativeDatesInfo: Record<RelativeDates, RelativeDateInfo> = {
    [RelativeDates.Today]: {
        name: RelativeDates.Today,
        formatedName: "Today",
        startDate: new Date(new Date().setHours(0, 0, 0, 0)),
        endDate: new Date(new Date().setHours(23, 59, 59, 999)),
    },
    [RelativeDates.Yesterday]: {
        name: RelativeDates.Yesterday,
        formatedName: "Yesterday",
        startDate: (() => {
            const startDate = new Date();
            startDate.setDate(startDate.getDate() - 1);
            startDate.setHours(0, 0, 0, 0);
            return startDate;
        })(),
        endDate: (() => {
            const endDate = new Date();
            endDate.setDate(endDate.getDate() - 1);
            endDate.setHours(23, 59, 59, 999);
            return endDate;
        })(),
    },
    [RelativeDates.Last7Days]: {
        name: RelativeDates.Last7Days,
        formatedName: "Last 7 days",
        startDate: new Date(new Date().setDate(new Date().getDate() - 6)),
        endDate: new Date(),
    },
    [RelativeDates.Last14Days]: {
        name: RelativeDates.Last14Days,
        formatedName: "Last 14 days",
        startDate: new Date(new Date().setDate(new Date().getDate() - 13)),
        endDate: new Date(),
    },
    [RelativeDates.Last30Days]: {
        name: RelativeDates.Last30Days,
        formatedName: "Last 30 days",
        startDate: new Date(new Date().setDate(new Date().getDate() - 29)),
        endDate: new Date(),
    },
    [RelativeDates.LastWeek]: {
        name: RelativeDates.LastWeek,
        formatedName: "Last Week",
        startDate: (() => {
            const date = new Date();
            const day = date.getDay();
            date.setDate(date.getDate() - day - 6); // Start of last week
            date.setHours(0, 0, 0, 0);
            return date;
        })(),
        endDate: (() => {
            const date = new Date();
            const day = date.getDay();
            date.setDate(date.getDate() - day); // End of last week
            date.setHours(23, 59, 59, 999);
            return date;
        })(),
    },
    [RelativeDates.LastMonth]: {
        name: RelativeDates.LastMonth,
        formatedName: "Last Month",
        startDate: (() => {
            const date = new Date();
            date.setMonth(date.getMonth() - 1, 1); // First day of last month
            date.setHours(0, 0, 0, 0);
            return date;
        })(),
        endDate: (() => {
            const date = new Date();
            date.setDate(0); // Last day of last month
            date.setHours(23, 59, 59, 999);
            return date;
        })(),
    },
    [RelativeDates.WeekToDate]: {
        name: RelativeDates.WeekToDate,
        formatedName: "Week to date",
        startDate: (() => {
            const date = new Date();
            const day = date.getDay();
            date.setDate(date.getDate() - day + 1); // Start of week to date is Monday, not Sunday
            date.setHours(0, 0, 0, 0);
            return date;
        })(),
        endDate: new Date(),
    },
    [RelativeDates.MonthToDate]: {
        name: RelativeDates.MonthToDate,
        formatedName: "Month to date",
        startDate: (() => {
            const date = new Date();
            date.setDate(1);
            date.setHours(0, 0, 0, 0);
            return date;
        })(),
        endDate: new Date(),
    },
};

export const TIME_RANGE_TOOLTIP = "Please enter a valid time range.";

export const MAX_HOURS = 23;
export const MAX_MINUTES_OR_SECONDS = 59;
export const MAX_MILLISECONDS = 999;
